export const APP_ROUTES = {
  GENERAL: {
    // LANDING PAGE SUB-ROUTES, MARKETING, E.T.C
    HOMEPAGE: '/',
    PRIVACY_POLICY: "/privacy-policy",
    TERMS_OF_USE: "/terms-of-use"
  },
  AUTH: {
    // LOGIN / SIGN UP / PWD RESET
    LOGIN: '/auth/login'
  },
  ONBOARDING: {
    // PERSONAL ONBOARDING ROUTES
    PERSONAL: {
      ROOT: "/onboarding/personal",
      BASIC_INFO: "/onboarding/personal/personal-info",
      ACCOUNT_VERIFICATION: "/onboarding/personal/account-verification",
      PHONE_ENTRY: "/onboarding/personal/phone-entry",
      PHONE_VERIFICATION: "/onboarding/personal/phone-verification",
      CHANGE_MOBILE: "/onboarding/personal/change-mobile",
      CHANGE_EMAIL: "/onboarding/personal/change-email",
      CONTACT_INFO: "/onboarding/personal/contact-info",
      SECURITY_OVERVIEW: "/onboarding/personal/security-overview",
      SECURITY_QUESTIONS: "/onboarding/personal/security-questions",
      PIN_SETUP: "/onboarding/personal/pin",
      VERIFICATION_OVERVIEW: "/onboarding/personal/verification/overview",
      VERIFICATION_IDENTITY: "/onboarding/personal/verification/identity",
    },
    // BUSINESS ONBOARDING ROUTES
    BUSINESS: {
      ROOT: "/onboarding/business",
      BUSINESS_PROFILE_OVERVIEW: "/onboarding/business/business-profile-overview",
      BUSINESS_TYPE: "/onboarding/business/business-type",
      REPRESENTATIVE_DETAILS: "/onboarding/business/representative-details",
      REPRESENTATIVE_FORM: "/onboarding/business/representative-form",
      COMPANY_DETAILS: "/onboarding/business/company-details",
      MEMBERS: "/onboarding/business/members",
      REVIEW: "/onboarding/business/review",
      UPLOAD: "/onboarding/business/upload",
      SECURITY_QUESTIONS: "/onboarding/business/security-questions",
      SECURITY_OVERVIEW: "/onboarding/business/security-overview",
      ACCOUNT_VERIFICATION: "/onboarding/business/account-verification",
      PHONE_ENTRY: "/onboarding/business/phone-entry",
      PHONE_VERIFICATION: "/onboarding/business/phone-verification",
      CHANGE_MOBILE: "/onboarding/business/change-mobile",
      CHANGE_EMAIL: "/onboarding/business/change-email",
    },
  },
  USER: {
    // ALL ROUTES FOR THE DASHBOARD
    DASHBOARD: {
      HOMEPAGE: '/user/dashboard',
      PAYMENTS: {
        REMITTANCE: '/user/dashboard/payments/remittance',
        BANK_TRANSFER: '/user/dashboard/payments/bank-transfer',
        CONVERT_FUNDS: '/user/dashboard/payments/convert-funds',
        DEPOSIT: '/user/dashboard/payments/deposit',
      },
      WALLET: '/user/dashboard/wallets',
    },
    ACCOUNTS: '/user/accounts',
    ACCOUNTS_REQUEST: '/user/accounts/request',
    TRADE: '/user/trade',
    TRANSFERS: '/user/transfers',
    TRANSACTIONS: '/user/transactions',
    REFERRALS: '/user/refer-and-earn',
    PROFILE: '/user/profile',
    SETTINGS: '/user/settings',
    RECIPIENTS: '/user/recipients',
  }
}